import { useSegmentsStore } from '@app/insights/store/segments'
import { useFiltersStore } from '@app/insights/store/filters'

export default {
  computed: {
    allClientsFakeSegment() {
      return { id: 0, name: I18n.t('segments.modal.all_companies') }
    },
  },
  methods: {
    selectAllClients() {
      const segmentsStore = useSegmentsStore()
      const hasFilters = useFiltersStore().getActiveFilters.length > 0

      // Clicking "All clients" returns to the clean default view: it drops the
      // selected segment, the period selection and all active filters. This
      // also resets when no segment is selected but filters are applied (so
      // re-clicking "All clients" while already there clears your filters).
      if (segmentsStore.segment || hasFilters) {
        segmentsStore.unselectSegment()
      }
    },
  },
}
